<a pRipple class="package-renewal-trigger p-d-flex p-flex-row p-ai-center" (click)="open()" title="Mua thêm">
  <i class="pi pi-shopping-cart"></i>
  <span>Mua thêm</span>
</a>

<p-dialog [(visible)]="visible"
          [modal]="true"
          [dismissableMask]="false"
          [resizable]="false"
          [draggable]="false"
          [style]="{width: '980px', maxWidth: '96vw'}"
          appendTo="body"
          (onHide)="close()">
  <p-header *ngIf="thresholdWarningVisible">
    <div class="renewal-dialog-title">
      <i class="pi pi-exclamation-triangle"></i>
      <div>
        <strong>Bạn sắp hết số lượng hóa đơn!</strong>
        <small *ngIf="status">
          Bạn hiện còn {{ status.remainingQuantity | number }} hóa đơn. Vui lòng gia hạn để tiếp tục sử dụng phần mềm.
        </small>
      </div>
    </div>
  </p-header>

  <div class="renewal-loading" *ngIf="loading">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <div *ngIf="!loading">
    <p-message *ngIf="!status?.configReady"
               severity="warn"
               text="Nhà cung cấp chưa cấu hình tài khoản nhận thanh toán. Vui lòng liên hệ hỗ trợ."></p-message>

    <div class="renewal-layout">
      <section class="renewal-packages">
        <h3>Bảng giá gia hạn hóa đơn</h3>
        <div class="renewal-table-wrap">
          <table>
            <thead>
            <tr>
              <th></th>
              <th>Gói gia hạn</th>
              <th>Số lượng hóa đơn</th>
              <th>Giá niêm yết (VND)</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let product of products"
                [class.selected]="selectedProduct?.productId === product.productId"
                (click)="selectProduct(product)">
              <td>
                <p-radioButton name="renewalProduct"
                               [value]="product"
                               [(ngModel)]="selectedProduct"
                               [disabled]="changingPackage || !!checkout || !status?.configReady"
                               (onClick)="selectProduct(product)"></p-radioButton>
              </td>
              <td>{{ product.productName }}</td>
              <td class="number">{{ product.amountFixed | number }}</td>
              <td class="number">{{ product.price | number }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <p class="renewal-note">Phần mềm KCT. Số lượng hóa đơn được cộng sau khi thanh toán được xác nhận.</p>
      </section>

      <section class="renewal-payment">
        <h3>Thông tin thanh toán</h3>

        <div class="awaiting-approval" *ngIf="checkout?.awaitingApproval">
          <i class="pi pi-clock"></i>
          <strong>Chờ xác nhận</strong>
          <span>Chúng tôi đang kiểm tra thanh toán của bạn. Vui lòng chờ ít phút.</span>
        </div>

        <ng-container *ngIf="checkout && !checkout.awaitingApproval">
          <div class="selected-summary">
            <span>Gói đã chọn</span>
            <strong>{{ selectedProduct?.productName || checkout.productName }}</strong>
            <span>Số tiền</span>
            <strong>{{ checkout.amount | number }} VND</strong>
          </div>
          <div class="renewal-qr" *ngIf="checkout.qrCodeBase64">
            <img [src]="checkoutQrCodeSrc" alt="Mã QR thanh toán"/>
          </div>
          <dl class="bank-information">
            <dt>Ngân hàng</dt><dd>{{ checkout.bankName }}</dd>
            <dt>Số tài khoản</dt>
            <dd class="copyable-value">
              <span>{{ checkout.accountNumber }}</span>
              <button pButton type="button"
                      icon="pi pi-copy"
                      class="p-button-rounded p-button-text p-button-sm copy-button"
                      title="Sao chép số tài khoản"
                      (click)="copyText(checkout.accountNumber, 'số tài khoản')"></button>
            </dd>
            <dt>Chủ tài khoản</dt><dd>{{ checkout.accountHolderName }}</dd>
            <dt>Nội dung CK</dt>
            <dd class="copyable-value">
              <span>{{ checkout.transferContent || checkout.memo }}</span>
              <button pButton type="button"
                      icon="pi pi-copy"
                      class="p-button-rounded p-button-text p-button-sm copy-button"
                      title="Sao chép nội dung chuyển khoản"
                      (click)="copyText(checkout.transferContent || checkout.memo, 'nội dung chuyển khoản')"></button>
            </dd>
          </dl>
          <div class="transfer-warning">
            <i class="pi pi-exclamation-triangle"></i>
            <span>Quý khách vui lòng kiểm tra rõ thông tin chuyển khoản trước khi xác nhận giao dịch.</span>
          </div>
        </ng-container>

        <div class="empty-payment" *ngIf="!checkout">
          <i class="pi pi-qrcode"></i>
          <span *ngIf="!selectedProduct">Chọn một gói để tạo mã thanh toán.</span>
          <span *ngIf="selectedProduct">Nhấn Tạo mã QR để lấy thông tin thanh toán.</span>
        </div>
      </section>
    </div>

    <form [formGroup]="contactForm" class="renewal-contact" *ngIf="checkout">
      <div class="p-field">
        <label>Email <span class="required">*</span></label>
        <input pInputText type="email" formControlName="emailAddress"/>
        <app-validator [control]="contactForm.get('emailAddress')"></app-validator>
      </div>
      <div class="p-field">
        <label>Số điện thoại <span class="required">*</span></label>
        <input pInputText type="text" formControlName="contactNumber"/>
        <app-validator [control]="contactForm.get('contactNumber')"></app-validator>
      </div>
    </form>

    <div class="renewal-dismiss" *ngIf="thresholdWarningVisible">
      <p-checkbox [(ngModel)]="suppressToday" [binary]="true"
                  inputId="suppressRenewalToday"></p-checkbox>
      <label for="suppressRenewalToday">Không thông báo lại trong ngày hôm nay</label>
    </div>
  </div>

  <p-footer>
    <p-button label="Thoát"
              icon="pi pi-times"
              styleClass="p-button-text p-button-plain"
              [disabled]="submitting || changingPackage"
              (onClick)="exit()"></p-button>
    <p-button *ngIf="checkout && !checkout.awaitingApproval"
              label="Chọn lại gói"
              icon="pi pi-arrow-left"
              styleClass="p-button-outlined"
              [disabled]="submitting"
              (onClick)="cancelPayment()"></p-button>
    <p-button *ngIf="!checkout"
              label="Tạo mã QR"
              icon="pi pi-qrcode"
              [loading]="changingPackage"
              [disabled]="!selectedProduct || !status?.configReady"
              (onClick)="createCheckout()"></p-button>
    <p-button *ngIf="checkout && !checkout.awaitingApproval"
              label="Đã thanh toán"
              icon="pi pi-check"
              [disabled]="submitting"
              (onClick)="reportPayment()"></p-button>
  </p-footer>
</p-dialog>
